// extracted by mini-css-extract-plugin
export default {"headerLinkBlock":"headerLinkBlock-D_Nqw","removeLink":"removeLink-yIx4q","cancelButton":"cancelButton-fA6LN"};